import { useIntl } from 'react-intl';

import { AutoDismissFlag } from '@atlaskit/flag';
import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import { token } from '@atlaskit/tokens';

import { ComponentFlagId, HandleDismissedType } from 'src/redux/flags/types';

import { messages } from './give-feedback.i18n';

type Props = {
  id: ComponentFlagId;
  props: {};
} & HandleDismissedType;

export const GiveFeedbackSuccessFlag = ({
  id,
  props,
  ...otherProps
}: Props): JSX.Element => {
  const intl = useIntl();
  return (
    <AutoDismissFlag
      {...otherProps}
      id={id}
      description={intl.formatMessage(messages.giveFeedbackSuccessBody)}
      icon={
        <CheckCircleIcon
          spacing="spacious"
          color={token('color.icon.success')}
          label="success"
        />
      }
      title={intl.formatMessage(messages.giveFeedbackSuccessTitle)}
    />
  );
};
